import { Button, Form } from '@themesberg/react-bootstrap';
import React from 'react'
import ImageUpload from './ImageUpload';

export const AddTicketTableRow = (props) => {
  const { rIndex, numbers, amount, images, onDelete, onChangeAmount, onChangeNumbers, onChangeImage, maxDigits = 6 } = props;
  return (
    <tr>
      <td className="text-center">
        {rIndex + 1}
      </td>
      <td className="text-center">
        <Form.Control 
          required 
          type="text" 
          maxLength={maxDigits}
          defaultValue={numbers} 
          placeholder="" 
          onInput={(evt) => {
            evt.target.value = evt.target.value.replace(/\D/g, '').slice(0, maxDigits)
          }}
          onChange={(evt) => onChangeNumbers(rIndex, evt.target.value)} 
        />
      </td>
      <td className="text-center">
        <Form.Control required type="number" defaultValue={`${amount}`} placeholder="" onChange={(evt) => onChangeAmount(rIndex, parseInt(evt.target.value))} />
      </td>
      <td className="text-center">
        <ImageUpload value={images} onChange={(payload) => onChangeImage(rIndex, payload)} />
      </td>
      <td className="text-center">
        <Button variant='danger' onClick={() => onDelete(rIndex)}>
          Xóa
        </Button>
      </td>
    </tr>
  );
};
